import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ProviderBadges, Stars } from "@/components/Badges";
import { MapPin, Clock, ArrowRight } from "lucide-react";

export default function ProviderCard({ provider, index = 0 }) {
  const navigate = useNavigate();
  const minPrice = Math.min(...(provider.services?.map((s) => s.price) || [0]));
  const img = provider.profile_photo || provider.photos?.[0];

  return (
    <div
      data-testid={`provider-card-${provider.provider_id}`}
      className="card-hover bg-white rounded-2xl border border-border overflow-hidden flex flex-col fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative h-44 overflow-hidden">
        <img src={img} alt={provider.business_name} className="w-full h-full object-cover" />
        <div className="absolute top-3 left-3"><ProviderBadges badges={provider.badges} /></div>
        {provider.seasonal_services?.length > 0 && (
          <span data-testid="seasonal-badge" className="absolute top-3 right-3 bg-gold text-white text-[11px] font-semibold px-2 py-1 rounded-full">In season</span>
        )}
        {provider.instant_booking && (
          <span className="absolute bottom-3 right-3 bg-lawn text-white text-[11px] font-semibold px-2 py-1 rounded-full">Instant Book</span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display font-bold text-lg text-lawn-ink leading-tight">{provider.business_name}</h3>
        </div>
        <div className="mt-1.5"><Stars rating={provider.rating} count={provider.review_count} /></div>
        <div className="mt-3 flex items-center gap-4 text-sm text-muted-foreground">
          <span className="inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {provider.city || "Local"}</span>
          <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {provider.response_time_hours}h response</span>
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {provider.services?.slice(0, 3).map((s) => (
            <span key={s.category} className="text-[11px] bg-muted px-2 py-0.5 rounded-full text-muted-foreground">{s.name}</span>
          ))}
        </div>
        <div className="mt-4 pt-4 border-t border-border flex items-center justify-between">
          <div>
            <span className="text-xs text-muted-foreground">from</span>
            <p className="font-display font-extrabold text-xl text-lawn-ink">${minPrice}</p>
          </div>
          <Button
            data-testid={`view-provider-${provider.provider_id}`}
            onClick={() => navigate(`/provider/${provider.provider_id}`)}
            className="rounded-full bg-lawn hover:bg-lawn-dark gap-1 font-semibold"
          >
            View <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
